import { render, staticRenderFns } from "./HomeBox.vue?vue&type=template&id=fe36f046&scoped=true&"
import script from "./HomeBox.vue?vue&type=script&lang=js&"
export * from "./HomeBox.vue?vue&type=script&lang=js&"
import style0 from "./HomeBox.vue?vue&type=style&index=0&id=fe36f046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe36f046",
  null
  
)

export default component.exports